module.exports = __webpack_public_path__ + "static/media/控制手柄模块.ec3499ee.png";